<div class="aui-group" *ngIf="!loading; else loadingSpinner">
  <div class="notes-list">
    <span *ngIf="notes.length === 0"
      >No notes that have keyword
      <app-lozenge
        [type]="LozengeType.New"
        [label]="jiraIssue?.getKey() ?? 'no-isssue-key'"
        [subtle]="true"
      ></app-lozenge>
      were found.</span
    >
    <ng-container *ngIf="notes.length > 0">
      <app-notes [notes]="notes" [selectedNote]="selectedNote" (onSelectedNote)="onSelectedNote($event)"></app-notes>
    </ng-container>
  </div>
</div>
<ng-template #loadingSpinner>
  <div class="aui-group spinner-center">
    <p>Loading details...</p>
    <app-spinner></app-spinner>
  </div>
</ng-template>
